import React from 'react';
import Modal from '@carvana/showroom-modal';
import {
  ModalTitle,
  ModalContent,
  ModalMessage,
  CautionImage,
} from './BridgecrestCustomError.styles';
import { currentAssetsUrl } from '../../../utils/baseUrlUtil';

const BridgecrestCustomError = ({
  isOpen,
  header,
  title,
  message,
  closeModal,
}: any) => {
  return (
    <Modal
      className="bridegcrestCustomError"
      headerText={header}
      closeModal={closeModal}
      isOpen={isOpen}
      testHook="my-cars-modal"
      mode="light"
      portalDivId="bridgecrest-api-error"
    >
      <ModalContent>
        <CautionImage
          src={`${currentAssetsUrl(
            process.env.NODE_ENV
          )}/op-assets/my-cars/Caution.png`}
        />
        <ModalTitle>{title}</ModalTitle>
        <ModalMessage>{message}</ModalMessage>
      </ModalContent>
    </Modal>
  );
};

export default BridgecrestCustomError;
